import './scss/index.scss'
import {DialogImageComponent} from './DialogImageComponent'


const DialogImagePackage = {
    name: 'UIDialogImage',
    configure: function(config) {
        config.addComponent('UIDialogImage', DialogImageComponent, false, 'dialog-image')

        config.addLabel('Image meta data', {
            sv: 'Bildmetadata'
        })

        config.addLabel('Extended meta data', {
            sv: 'Utökad bildinformation'
        })
        config.addLabel('Photo date', {
            sv: 'Fotodatum'
        })

        config.addLabel('Imported', {
            sv: 'Importerad'
        })

        config.addLabel('Image description', {
            sv: 'Bildbeskrivning'
        })

        config.addLabel('Instructions', {
            sv: 'Instruktioner'
        })

        config.addLabel('Object name', {
            sv: 'Objektnamn'
        })

        config.addLabel('Add creator', {
            sv: 'Lägg till skapare'
        })

        config.addLabel('Unknown name', {
            sv: 'Okänt namn'
        })

        config.addLabel('Credit', {
            sv: 'Tillskrivning'
        })

        config.addLabel('Image data saved to archive', {
            sv: 'Bildens arkivdata har sparats i arkivet'
        })

        config.addLabel('Error! Image data could not be saved.', {
            sv: 'Ett fel uppstod! Bildens arkivdata kunde inte sparas.'
        })

        config.addLabel('Not published', {
            sv: 'Ej publicerad'
        })

        config.addLabel('Pending approval', {
            en: 'Ready for approval',
            sv: 'Klar för godkännande'
        })

        config.addLabel('Published', {
            sv: 'Publicerad'
        })

        config.addLabel('Unpublished', {
            sv: 'Avpublicerad'
        })

    }
}

export {DialogImagePackage}
